'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(['\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  background-color: #fff;\n  border: 1px solid rgba(0,0,0,.75);\n  border-radius: .25rem;\n  margin: 20px;\n  padding: 5px;\n  width: calc(25% - 52px);\n  box-shadow: 5px 5px 5px gray;\n  transform: none;\n\n  &.grid-cols-2 {width: calc(50% - 52px);}\n  &.grid-cols-3 {width: calc(75% - 52px);}\n  &.grid-cols-4 {width: calc(100% - 52px);}\n\n  @media (max-width: 1024px) {\n    width: calc(33% - 52px);\n    &.grid-cols-2 {width: calc(66% - 52px);}\n    &.grid-cols-3 {width: calc(100% - 52px);}\n    &.grid-cols-4 {width: calc(100% - 52px);}\n  }\n\n  @media (max-width: 782px) {\n    width: calc(50% - 52px);\n    &.grid-cols-2 {width: calc(50% - 52px);}\n    &.grid-cols-3 {width: calc(100% - 52px);}\n    &.grid-cols-4 {width: calc(100% - 52px);}\n  }\n\n  @media (max-width: 415px), (max-height: 415px) {\n    width: calc(100vw - 52px);\n    &.grid-cols-2 {width: calc(100% - 52px);}\n    &.grid-cols-3 {width: calc(100% - 52px);}\n    &.grid-cols-4 {width: calc(100% - 52px);}\n  }\n\n  .controls {\n    width: 100%;\n  }\n'], ['\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  background-color: #fff;\n  border: 1px solid rgba(0,0,0,.75);\n  border-radius: .25rem;\n  margin: 20px;\n  padding: 5px;\n  width: calc(25% - 52px);\n  box-shadow: 5px 5px 5px gray;\n  transform: none;\n\n  &.grid-cols-2 {width: calc(50% - 52px);}\n  &.grid-cols-3 {width: calc(75% - 52px);}\n  &.grid-cols-4 {width: calc(100% - 52px);}\n\n  @media (max-width: 1024px) {\n    width: calc(33% - 52px);\n    &.grid-cols-2 {width: calc(66% - 52px);}\n    &.grid-cols-3 {width: calc(100% - 52px);}\n    &.grid-cols-4 {width: calc(100% - 52px);}\n  }\n\n  @media (max-width: 782px) {\n    width: calc(50% - 52px);\n    &.grid-cols-2 {width: calc(50% - 52px);}\n    &.grid-cols-3 {width: calc(100% - 52px);}\n    &.grid-cols-4 {width: calc(100% - 52px);}\n  }\n\n  @media (max-width: 415px), (max-height: 415px) {\n    width: calc(100vw - 52px);\n    &.grid-cols-2 {width: calc(100% - 52px);}\n    &.grid-cols-3 {width: calc(100% - 52px);}\n    &.grid-cols-4 {width: calc(100% - 52px);}\n  }\n\n  .controls {\n    width: 100%;\n  }\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _titleContent = require('./title-content');

var _titleContent2 = _interopRequireDefault(_titleContent);

var _buttonGroupContent = require('./button-group-content');

var _buttonGroupContent2 = _interopRequireDefault(_buttonGroupContent);

var _richTextContent = require('./rich-text-content');

var _richTextContent2 = _interopRequireDefault(_richTextContent);

var _articleContent = require('./article-content');

var _articleContent2 = _interopRequireDefault(_articleContent);

var _imageContent = require('./image-content');

var _imageContent2 = _interopRequireDefault(_imageContent);

var _audioContent = require('./audio-content');

var _audioContent2 = _interopRequireDefault(_audioContent);

var _videoContent = require('./video-content');

var _videoContent2 = _interopRequireDefault(_videoContent);

var _socialMediaLinksContent = require('./social-media-links-content');

var _socialMediaLinksContent2 = _interopRequireDefault(_socialMediaLinksContent);

var _interactions = require('./interactions');

var _interactions2 = _interopRequireDefault(_interactions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Card = _styledComponents2.default.div(_templateObject);

/** @class Content
  * A class representing booth content.  It renders
  * the appropriate content, along with "Add to Showbag",
  * "Add to Wishlist", and "Buy It Now" buttons
  * when appropriate.
  */

var Content = function (_Component) {
  _inherits(Content, _Component);

  function Content() {
    _classCallCheck(this, Content);

    return _possibleConstructorReturn(this, (Content.__proto__ || Object.getPrototypeOf(Content)).apply(this, arguments));
  }

  _createClass(Content, [{
    key: 'render',

    /** @method render
     * Renders the appropriate content component.
     */
    value: function render() {
      var content = null;
      switch (this.props.type) {
        case 'title':
          content = _react2.default.createElement(_titleContent2.default, this.props);
          break;
        case 'button-group':
          content = _react2.default.createElement(_buttonGroupContent2.default, this.props);
          break;
        case 'rich-text':
          content = _react2.default.createElement(_richTextContent2.default, this.props);
          break;
        case 'article':
          content = _react2.default.createElement(_articleContent2.default, this.props);
          break;
        case 'image':
          content = _react2.default.createElement(_imageContent2.default, this.props);
          break;
        case 'audio':
          content = _react2.default.createElement(_audioContent2.default, this.props);
          break;
        case 'video':
          content = _react2.default.createElement(_videoContent2.default, this.props);
          break;
        case 'social-media-links':
          content = _react2.default.createElement(_socialMediaLinksContent2.default, this.props);
          break;
        default:
          content = '';
      }
      return _react2.default.createElement(
        Card,
        { className: 'grid-item grid-cols-' + this.props.columns },
        _react2.default.createElement(_interactions2.default, this.props),
        content
      );
    }
  }]);

  return Content;
}(_react.Component);

exports.default = Content;


Content.propTypes = {
  name: _propTypes2.default.string.isRequired,
  type: _propTypes2.default.string.isRequired,
  swag: _propTypes2.default.bool
};


//////////////////
// WEBPACK FOOTER
// ../vexpo-components/build/content/content.js
// module id = 177
// module chunks = 0